// Copyright 2025. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { COLORS } from 'admin/core/theme';

interface IStyledCodeEditorProps {
    height: number;
    width?: number;
    disabled?: boolean;
}

export const StyledCodeEditor = styled.div<IStyledCodeEditorProps>`
    .CodeMirror {
        height: ${props => props.height}px;
        width: ${props => props.width ? `${props.width}px` : 'auto'};
        border: 1px solid ${props => props.disabled ? COLORS.GREY_50 : COLORS.GREY_40};
        box-sizing: border-box;
        border-radius: 2px;
        z-index: 0;
        background-color: ${props => props.disabled ? COLORS.GREY_20 : COLORS.WHITE};
        cursor: ${props => props.disabled ? 'not-allowed' : 'text'};
        pointer-events: ${props => props.disabled ? 'none' : 'auto'}
    }
`;
